import { useState } from "react";
import { Link } from "react-router-dom";
import { SITE, SERVICES } from "../data/site";

const CONTACT_API =
  process.env.REACT_APP_CONTACT_API ||
  (process.env.NODE_ENV === "production"
    ? "https://ccs-gm-contact.t6mpknwd4z.workers.dev/api/contact"
    : "/api/contact");

export default function ContactForm({ defaultService = "" }) {
  const [status, setStatus] = useState("");
  const [error, setError] = useState(false);
  const [sending, setSending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    if (data.get("company")) {
      setError(false);
      setStatus("Danke. Wir melden uns in Kürze.");
      return;
    }

    const payload = {
      name: data.get("name"),
      phone: data.get("phone"),
      email: data.get("email"),
      service: data.get("service"),
      message: data.get("message"),
    };
    const subject = `Anfrage über ccs-gm.de – ${payload.service || "Allgemein"}`;

    setSending(true);
    setStatus("");
    setError(false);
    try {
      const res = await fetch(CONTACT_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      const json = await res.json().catch(() => null);
      if (!res.ok || !json?.ok) {
        const err = new Error(json?.error || "Versand fehlgeschlagen.");
        err.status = res.status;
        err.fromApi = Boolean(json?.error);
        throw err;
      }
      setStatus("Danke. Wir melden uns in Kürze.");
      form.reset();
    } catch (err) {
      if (err.fromApi) {
        setError(true);
        setStatus(err.message);
      } else {
        const body = [
          payload.message,
          "",
          `Telefon: ${payload.phone}`,
          `Leistung: ${payload.service}`,
        ].join("\n");
        window.location.href = `mailto:${SITE.email}?subject=${encodeURIComponent(
          subject
        )}&body=${encodeURIComponent(body)}`;
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="form" onSubmit={onSubmit} noValidate={false}>
      <label className="hp" aria-hidden="true">
        Firma
        <input type="text" name="company" tabIndex={-1} autoComplete="off" />
      </label>
      <div className="form-row">
        <label className="field">
          <span>Name</span>
          <input name="name" autoComplete="name" required />
        </label>
        <label className="field">
          <span>Telefon</span>
          <input name="phone" type="tel" autoComplete="tel" required />
        </label>
      </div>
      <label className="field">
        <span>E-Mail</span>
        <input name="email" type="email" autoComplete="email" required />
      </label>
      <label className="field">
        <span>Leistung</span>
        <select name="service" defaultValue={defaultService}>
          <option value="">Bitte wählen</option>
          {SERVICES.map((s) => (
            <option key={s.slug} value={s.title}>
              {s.title}
            </option>
          ))}
          <option value="Reinigung">Reinigung</option>
          <option value="Sonstiges">Sonstiges</option>
        </select>
      </label>
      <label className="field">
        <span>Ihr Vorhaben</span>
        <textarea
          name="message"
          required
          placeholder="Kurz beschreiben, was ansteht. Bei Umzug: Abholort, Zielort, Etage/Aufzug, Wunschtermin – Fotos helfen."
        />
      </label>
      <p className="muted" style={{ fontSize: "0.82rem" }}>
        Mit dem Absenden willigen Sie in die Verarbeitung Ihrer Angaben zur
        Bearbeitung der Anfrage ein. Details in der{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>
      <button className="btn btn-primary" type="submit" disabled={sending}>
        {sending ? "Wird gesendet…" : "Anfrage senden"}
      </button>
      {status ? (
        <p className={`form-status${error ? " is-error" : ""}`} role="status">
          {status}
        </p>
      ) : null}
    </form>
  );
}
